import { createAction } from 'redux-act'

// ----------------------------------------
// FETCH ORDERS
// ----------------------------------------
export const fetchOrdersStart = createAction<string>('hmPay - fetch orders start')

export const fetchOrdersSuccess = createAction<any>(
  'hmPay - fetch orders success',
  (klarnaResponse, filterName) => ({ ...klarnaResponse, filterName }),
)

export const fetchOrdersFail = createAction<any>(
  'hmPay - fetch orders fail',
  (error, filterName) => ({
    error,
    filterName,
  }),
)

// ----------------------------------------
// FETCH ORDER
// ----------------------------------------
export const fetchOrderStart = createAction<any>('hmPay - fetch order start')

export const fetchOrderSuccess = createAction<any>('hmPay - fetch order success')

export const fetchOrderFail = createAction<any>('hmPay - fetch order fail')

// ----------------------------------------
// LOAD MORE ORDERS
// ----------------------------------------
export const loadMoreOrdersStart = createAction<any>('hmPay - load more orders start')
export const loadMoreOrdersSuccess = createAction<any>(
  'hmPay - load more orders success',
  (klarnaResponse, filterName) => ({ ...klarnaResponse, filterName }),
)
export const loadMoreOrdersFail = createAction<any>(
  'hmPay - load more orders fail',
  (error, filterName) => ({ error, filterName }),
)

// ----------------------------------------
// FETCH MONTHLY INVOICES (Plural)
// ----------------------------------------
export const fetchMonthlyInvoicesStart = createAction('hmPay - fetch monthly invoices start')

export const fetchMonthlyInvoicesSuccess = createAction<any>(
  'hmPay - fetch monthly invoices success',
)

export const fetchMonthlyInvoicesFail = createAction<any>('hmPay - fetch monthly invoices fail')

// ----------------------------------------
// FETCH MONTHLY INVOICE (Single)
// ----------------------------------------
export const fetchMonthlyInvoiceStart = createAction<any>('hmPay - fetch monthly invoice start')

export const fetchMonthlyInvoiceSuccess = createAction<any>('hmPay - fetch monthly invoice success')

export const fetchMonthlyInvoiceFail = createAction<any>('hmPay - fetch monthly invoice fail')

// ----------------------------------------
// FETCH MONTHLY INVOICE ORDERS
// ----------------------------------------
export const fetchMonthlyInvoiceOrdersStart = createAction<any>(
  'hmPay - fetch monthly invoice orders start',
)

export const fetchMonthlyInvoiceOrdersSuccess = createAction<any>(
  'hmPay - fetch monthly invoice orders success',
  (collectionId, klarnaResponse) => ({ collectionId, klarnaResponse }),
)

export const fetchMonthlyInvoiceOrdersFail = createAction<any>(
  'hmPay - fetch monthly invoice orders fail',
)

// ----------------------------------------
// OTHER
// ----------------------------------------

export const toggleExpandedPath = createAction<any>(
  'hmPay - toggle expanded path',
  (pathWithFilter, id) => ({ pathWithFilter, id }),
)

export const setIsLoadMoreUsed = createAction<boolean>('hmPay - set is load more used')

export const setKlarnaAuthStart = createAction('hmPay - set klarna auth start')

export const fetchKlarnaProfileStart = createAction('hmPay - fetch klarna profile start')

export const fetchKlarnaProfileSuccess = createAction<any>('hmPay - fetch klarna profile success')

export const setSelectedTab = createAction<any>('hmPay - set selected tab')

export default {
  fetchOrdersStart,
  fetchOrdersSuccess,
  fetchOrdersFail,

  fetchOrderStart,
  fetchOrderSuccess,
  fetchOrderFail,

  loadMoreOrdersStart,
  loadMoreOrdersSuccess,
  loadMoreOrdersFail,

  toggleExpandedPath,

  setKlarnaAuthStart,

  fetchKlarnaProfileStart,
  fetchKlarnaProfileSuccess,

  setSelectedTab,
}
